"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/InviteContactModal/Form.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);








var _contact = require('shared/enum/contact');
var _inviteContact = require('shared/services/inviteContact');
var _entities = require('shared/transforms/entities');




var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _myRelations = require('shared/selectors/myRelations');

var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');





var _Forms = require('web/screens/Directory/Forms');

var _useOrgPatientTags = require('web/screens/Directory/DirectoryCreateNewModal/useOrgPatientTags'); var _useOrgPatientTags2 = _interopRequireDefault(_useOrgPatientTags);
var _OrgLimitNotice = require('web/components/Upgrade/OrgLimitNotice'); var _OrgLimitNotice2 = _interopRequireDefault(_OrgLimitNotice);
var _Form = require('web/components/Form');


















// Memoized, as connect() was.
const InviteContactForm = _react.memo.call(void 0, function InviteContactForm ({
  contactRelType,
  defaultEmail: initialDefaultEmail = '',
  defaultPhone: initialDefaultPhone = '',
  defaultFirstName: initialDefaultFirstName = '',
  defaultLastName: initialDefaultLastName = '',
  onEntityInvited,
  onClose,
  orgKeyContext,
  pinnedOrgKey,
  patientPinnedOrgKey,
  isNewConversation = false,
}) {
  // The old mapState's selectors; each returns a stored or memoized value.
  const allOrgs = _hooks.useAppSelector.call(void 0, _org.selectOrgsV2)
  const activeOrgs = _hooks.useAppSelector.call(void 0, _user.selectMyActiveOrgsList)
  const patientMessagingOrgs = _hooks.useAppSelector.call(void 0, 
    state => _org.selectPatientMessagingOrgs.call(void 0, state, contactRelType),
  )
  const isPatientVariant = contactRelType === _contact.CONTACT_REL_TYPES.PATIENT
  const pinnedOrg = _hooks.useAppSelector.call(void 0, state => isPatientVariant && pinnedOrgKey
    ? _nullishCoalesce(_org.selectOrgByKey.call(void 0, pinnedOrgKey, state), () => ( null))
    : null)
  const [defaultEmail] = _react.useState.call(void 0, initialDefaultEmail)
  const [defaultPhone] = _react.useState.call(void 0, initialDefaultPhone)
  const [defaultFirstName] = _react.useState.call(void 0, initialDefaultFirstName)
  const [defaultLastName] = _react.useState.call(void 0, initialDefaultLastName)
  const isOrgScopedContact = contactRelType === _contact.CONTACT_REL_TYPES.PATIENT
    || contactRelType === _contact.CONTACT_REL_TYPES.COWORKER
  // The current org is the From sender's org in a composer, else the org in view.
  const currentPatientOrgKey = isPatientVariant
    ? pinnedOrgKey || orgKeyContext
    : null
  const currentOrgHasTextingNumber = _hooks.useAppSelector.call(void 0, 
    state => _myRelations.selectDoIHavePhoneTeamInOrg.call(void 0, state, currentPatientOrgKey),
  )
  // Without a texting number the current org isn't assumed; the user picks.
  const mustChoosePatientOrg = isPatientVariant
    && isNewConversation
    && !patientPinnedOrgKey
    && !currentOrgHasTextingNumber
  const pinnedPatientOrgKey = isPatientVariant && !mustChoosePatientOrg
    ? pinnedOrgKey
    : null
  const patientOrgOptions = patientMessagingOrgs.map(org => ({
    value: org.OrgKey,
    label: org.Name,
  }))
  if (
    pinnedPatientOrgKey
    && !patientOrgOptions.some(option => option.value === pinnedPatientOrgKey)
  ) {
    patientOrgOptions.push({
      value: pinnedPatientOrgKey,
      label: _nullishCoalesce(_optionalChain([pinnedOrg, 'optionalAccess', _ => _.Name]), () => ( 'Selected organization')),
    })
  }
  const orgOptions = contactRelType === _contact.CONTACT_REL_TYPES.PATIENT
    ? patientOrgOptions
    : activeOrgs.map(org => ({ value: org.OrgKey, label: org.Name }))
  const shouldShowOrgControl = isOrgScopedContact
    && (mustChoosePatientOrg || orgOptions.length > 1 || !!pinnedPatientOrgKey)
  const onlyPatientOrgKey = patientMessagingOrgs.length === 1
    ? patientMessagingOrgs[0].OrgKey
    : ''
  const defaultSelectedOrgKey = mustChoosePatientOrg
    ? onlyPatientOrgKey
    : pinnedPatientOrgKey
      || _optionalChain([orgOptions, 'access', _2 => _2.find, 'call', _3 => _3(option => option.value === orgKeyContext), 'optionalAccess', _4 => _4.value])
      || _optionalChain([orgOptions, 'access', _5 => _5[0], 'optionalAccess', _6 => _6.value])
      || orgKeyContext
  const [selectedOrgKey, setSelectedOrgKey] =
    _react.useState(defaultSelectedOrgKey)
  const effectiveOrgKey = pinnedPatientOrgKey || selectedOrgKey || null
  const selectedOrgName = _nullishCoalesce(_optionalChain([orgOptions
, 'access', _7 => _7.find, 'call', _8 => _8(option => option.value === effectiveOrgKey), 'optionalAccess', _9 => _9.label])
, () => ( 'Selected organization'))

  _react.useEffect.call(void 0, () => {
    setSelectedOrgKey(defaultSelectedOrgKey)
  }, [contactRelType, defaultSelectedOrgKey])

  // The patient table's Tags field, for the org the patient goes to.
  const patientTags = _useOrgPatientTags2.default.call(void 0, isPatientVariant ? effectiveOrgKey : null)

  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  

  const handleSubmit = _react.useCallback.call(void 0, 
    async (data, tags) => {
      if (!contactRelType || !effectiveOrgKey) return Promise.reject()
      _amplitude2.default.logEvent("Invite Contact", { contactRelType })
      const patientTags = tags && { TagKeys: tags.TagKeys, NewTagNames: tags.NewNames }
      return _inviteContact.inviteContact.call(void 0, data, contactRelType, effectiveOrgKey, patientTags)
        .then(invitee => {
          if (contactRelType === _contact.CONTACT_REL_TYPES.PATIENT) {
            const entity = _entities.mapPatientToEntity.call(void 0, allOrgs)(invitee )
            onEntityInvited(entity)
          }

          if (contactRelType === _contact.CONTACT_REL_TYPES.COWORKER) {
            const entity = _entities.mapUserToEntity.call(void 0, allOrgs)(invitee )
            onEntityInvited(entity)
          }

          if (contactRelType === _contact.CONTACT_REL_TYPES.EXTERNAL) {
            const entity = _entities.mapUserToEntity.call(void 0, allOrgs)(invitee )
            onEntityInvited(entity)
          }

          onClose()
        })
        .catch(() => showWarningBar('Failed to invite contact'))
    },
    [contactRelType, effectiveOrgKey, showWarningBar, allOrgs, onClose, onEntityInvited],
  )

  _react.useEffect.call(void 0, 
    () => {
      _amplitude2.default.logEvent("Open Invite Contact Modal", { contactRelType })
    },
    [contactRelType],
  )

  const orgControl = mustChoosePatientOrg ? (
    _react2.default.createElement(_Forms.PatientOrgChoice, {
      orgs: patientMessagingOrgs,
      value: selectedOrgKey,
      onChange: setSelectedOrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
    )
  ) : shouldShowOrgControl ? (
    _react2.default.createElement(_Form.InputSectionWrapper, {
      title: "Organization",
      className: "invite-contact--org-picker",
      shouldCaptureFocus: !pinnedPatientOrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}

      ,  pinnedPatientOrgKey
        ? (
            _react2.default.createElement('strong', { className: "invite-contact--org-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}}
              ,  selectedOrgName 
            )
          )
        : (
            _react2.default.createElement(_Form.SimpleSelect, {
              value: _nullishCoalesce(effectiveOrgKey, () => ( undefined)),
              onChange: setSelectedOrgKey,
              options: orgOptions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 197}}
            )
          )
      
    )
  ) : null

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  contactRelType === _contact.CONTACT_REL_TYPES.EXTERNAL && (
        _react2.default.createElement(_Forms.ExternalCollaboratorForm, {
          defaultEmail: defaultEmail,
          onSubmit: handleSubmit,
          onCancel: onClose,
          submitBtnLabel: "Invite",
          controlsClassName: "invite-contact--form-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}
        )
      )
      ,  contactRelType === _contact.CONTACT_REL_TYPES.COWORKER && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_OrgLimitNotice2.default, { orgKey: _nullishCoalesce(effectiveOrgKey, () => ( orgKeyContext)), addedUsersCount: 1, __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}} )
          , _react2.default.createElement(_Forms.CoworkerForm, {
            defaultEmail: defaultEmail,
            defaultFirstName: defaultFirstName,
            defaultLastName: defaultLastName,
            onSubmit: handleSubmit,
            onCancel: onClose,
            submitBtnLabel: "Invite",
            orgKeyContext: _nullishCoalesce(effectiveOrgKey, () => ( orgKeyContext)),
            hideOrgNotice: shouldShowOrgControl,
            beforeControls: orgControl,
            controlsClassName: "invite-contact--form-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}
          )
        )
      )
      ,  contactRelType === _contact.CONTACT_REL_TYPES.PATIENT && (
        _react2.default.createElement(_Forms.PatientForm, {
          defaultEmail: defaultEmail,
          defaultPhone: defaultPhone,
          defaultFirstName: defaultFirstName,
          defaultLastName: defaultLastName,
          onSubmit: handleSubmit,
          onCancel: onClose,
          submitBtnLabel: "Add",
          orgKeyContext: effectiveOrgKey,
          hideOrgNotice: shouldShowOrgControl,
          isSubmitDisabled: !effectiveOrgKey,
          beforeControls: orgControl,
          tags: patientTags,
          controlsClassName: "invite-contact--form-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}
        )
      )
    )
  )
})

exports. default = InviteContactForm
